import { getTaskStatus } from './apis/getTaskStatus.js';
export const subscribeToUpdateSiteTaskStatus = (httpClient, updateSiteTaskId, options = {}) => {
    const { onStatusChange, pollInterval = 1000, timeout = 1000 * 60 * 5 } = options;
    return new Promise((resolve, reject) => {
        const cleanup = () => {
            clearInterval(intervalId);
            clearTimeout(timeoutId);
        };
        const timeoutId = setTimeout(() => {
            cleanup();
            reject(new Error('deployDocument timeout exceeded'));
        }, timeout);
        const intervalId = setInterval(async () => {
            try {
                const taskStatus = await getTaskStatus(httpClient, updateSiteTaskId);
                onStatusChange?.(taskStatus);
                if (taskStatus.state === 'FAILED') {
                    cleanup();
                    reject(new Error(`Action ${taskStatus.action} failed with error: ${taskStatus.extras?.error}`));
                }
                if (taskStatus.action === 'CREATE_REVISION' && taskStatus.state === 'DONE') {
                    cleanup();
                    resolve(taskStatus.extras);
                }
            }
            catch (error) {
                cleanup();
                reject(error);
            }
        }, pollInterval);
    });
};
